import { defineStore } from 'pinia';

export const useCreateRoleDialog = defineStore('createRoleDialog', {
	state: () => ({
		isOpen: false,
		loading: true,
	}),
	actions: {
		open() {
			if (this.loading) return
			this.isOpen = true;
		},
		close() {
			if (this.loading) return
			this.isOpen = false;
		},
		startLoading() {
			this.loading = true;
		},
		stopLoading() {
			this.loading = false;
		}
	},
	getters: {
		isCreateRoleDialogOpen() {
			return this.isOpen
		}
	}
}); 